module.exports = __webpack_public_path__ + "static_pc/img/ower02.3ebb2d69.png";